<template>
    <div>
        <router-view
            class="pt-2"
            :global-settings-information="cGlobalSettingsInformation" />
    </div>
</template>

<script lang="ts" setup>
const store = $store()

onMounted(() => {
  useRouter().push({ name: 'pp-id-company-global-settings-gps' })
})

const cGlobalSettingsInformation = computed(() => {
  return store.globalSettings.getGlobalSettings
})
</script>
